import { css } from 'aphrodite';
import { forwardRef } from 'react';
import { s } from './styles';

export const TextArea = forwardRef<HTMLTextAreaElement, AphroditeStyled<React.ComponentProps<'textarea'>>>(
	({ styles = [], ...props }, ref) => {
		return <textarea className={css(s.textArea, ...styles)} ref={ref} {...props} />;
	}
);
TextArea.displayName = 'TextArea';
